<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-12 09:51:22
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-24 16:39:59
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperationProgress\list\components\cardList\components\goodsInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="yx-color-text-primary font-h4-regular Barlow-Medium">
		<span v-if="column.textType === 'money'">
			{{ row[column['key']] | formatEmpty | formatPrice }}
		</span>
		<span v-else-if="column.textType === 'num'">
			{{ row[column['key']] | formatEmpty | formatPrice2 }}
		</span>
		<span v-else class="font-h6-regular">
			{{ row[column['key']] }}
		</span>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	computed: {},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped>
</style>